import { take, call, put, fork } from 'redux-saga/effects';
import {
  getProgressRank,
  successGetProgressRank,
  failGetProgressRank,
  uploadSearchKeyword,
  getDayProgressSummary,
  successGetDayProgressSummary,
  failGetDayProgressSummary,
} from '../actions/user-data';
import superFetch from '../modules/superFetch';

// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleGetProgressRank() {
  while (true) {
    yield take(`${getProgressRank}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/user_data/gettotal/',
      type: 'GET',
    });

    if (payload && !err) {
      yield put(successGetProgressRank(Object.assign({}, payload)));
      continue;
    }
    yield put(failGetProgressRank(String(err)));
  }
}
export function* handleGetProgressSummary() {
  while (true) {
    yield take(`${getDayProgressSummary}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/user_data/getdayprogresssummary/',
      type: 'GET',
    });

    if (payload && !err) {
      yield put(successGetDayProgressSummary(Object.assign({}, payload)));
      continue;
    }
    yield put(failGetDayProgressSummary(String(err)));
  }
}
export function* handleUploadSearchKeyword() {
  while (true) {
    const action = yield take(`${uploadSearchKeyword}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/user_data/searchkeyword',
      type: 'POST',
      data: action.payload,
    });
    if (payload && !err) {
      continue;
    }
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleUploadSearchKeyword);
  yield fork(handleGetProgressRank);
  yield fork(handleGetProgressSummary);
}



// WEBPACK FOOTER //
// ./src/sagas/user-data.js